import Service from "../../../Services/index";
import moment from "moment";

const ExampleProduct = {
    namespaced: true,
    state: {
        example_product_list:[],
    },
    mutations: {
        GET_EXAMPLE_PRODUCT:(state,res)=>{
            state.example_product_list = res;
        },
    },
    actions: {
        setExampleProduct({commit},data){
            return Service.ExampleProduct.getExampleProduct(data).then(res=>{
                commit("GET_EXAMPLE_PRODUCT",res);
            });
        },
    }
};

export default ExampleProduct;
